import React, { Component } from "react";
import Loader from 'react-loader-spinner';
import Button from '@material-ui/core/Button';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import DateRangePicker, { DateRange } from '@material-ui/lab/DateRangePicker';
import DatePicker from '@material-ui/lab/DatePicker';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import Box from '@material-ui/core/Box';
import DTable from '../dtable.component';
import swal from 'sweetalert';

import AuthService from '../../services/auth/auth.service';
import CorporateService from '../../services/crm/corporatereports.service';

import UserContext from "../../contexts/UserContext";
import NoPermission from "../extras/nopermission.component";

export default class CorporateCustomerDetails extends Component {

    static contextType = UserContext;
    constructor(props){
        super(props);

        this.state = {
            user: [],
            data: [],
            show: false,
            showloader: true,
            user_id: 0,
            detailsCompany: '',
            detailsLandline: '',
            detailsAddress: '',
            detailsEmail: '',
            detailsAccountCreationDate: '',
            detailsNoOfStaff: '',
            detailsDiscountCode: '',
            detailsTotalSalesAllTime: '',
            detailsRequirements: '',
            contacts: [
                {
                    type: 'Main Contact',
                    fullname: '',
                    role: '',
                    mobile: '',
                    landline: '',
                    email: ''
                },
                {
                    type: 'Secondary Contact',
                    fullname: '',
                    role: '',
                    mobile: '',
                    landline: '',
                    email: ''
                }
            ],
            contactInfo: '',
            lastorderdate: '',
            totalbalance: 0,
            totalOrders: 0,
            total30days: 0,
            total12months: 0,
            totalorders30days: 0,
            totalorders12months: 0,
            history: [],
            allowed: true
        };
    }

    componentDidMount() {
        AuthService.checklogin().then(user => {
            this.setState({
                user: user
            });

            console.log({ user });

            AuthService.getUserPermisions(user)
            .then(response => {
                var userpermissions = response.data;
                console.log({userpermissions});
                    if(userpermissions.includes('corporate') || userpermissions.includes('all')) {
                    console.log('You are allowed!');
                    this.setState({
                        allowed: true
                    });
                    setTimeout(() => {
                        if (typeof this.props.params.id == 'undefined') {
                            this.setState({
                                user_id: 0,
                            });
                        } else {
                            this.setState({
                                user_id: this.props.params.id,
                            });
                            if (this.state.user_id != 0) {
                                this.getData();
                            }
                        }
                    }, 2000);
                } else {
                    console.log('You are not allowed!');
                    this.setState({
                        allowed: false
                    });
                }
            })
        }).catch(error => {
            window.location.href = '/login';
        });
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
        // console.log('handle change');
    }

    getData = () => {
        this.setState({
            showloader: true
        });
        console.log(this.state);
        CorporateService.getCorporateDetails(this.state.user_id)
        .then(response => {
            console.log({response});
            if(response.data!=null) {
                this.setState({
                    detailsCompany: response.data.basic.companyName,
                    detailsLandline: response.data.basic.landline,
                    detailsAddress: response.data.basic.address,
                    detailsEmail: response.data.basic.email,
                    detailsAccountCreationDate: response.data.basic.accountdate,
                    detailsNoOfStaff: response.data.basic.staff,
                    detailsDiscountCode: response.data.basic.couponCode,
                    detailsTotalSalesAllTime: response.data.basic.totalsales,
                    detailsRequirements: response.data.basic.requirements,
                    contactInfo: response.data.contactInfo,
                    lastorderdate: response.data.basic.lastorderdate,
                    totalbalance: response.data.totalbalance,
                    totalOrders: response.data.totalOrders,
                    total30days: response.data.total30days,
                    total12months: response.data.total12months,
                    totalorders30days: response.data.totalorders30days,
                    totalorders12months: response.data.totalorders12months,
                    history: response.data.history,
                });

                if(response.data.contacts.length>0) {
                    this.setState({
                        contacts: response.data.contacts    
                    });
                }

                this.setState({
                    showloader: false
                });
            }
        })
        .catch(error => {
            console.log({error});
            this.setState({
                showloader: false
            });
        });
    }

    changeContact = (index, key, value) => {
        var contactsTemp = this.state.contacts;

        if(key=='name') {
            contactsTemp[index].fullname = value;
        } else if(key=='role') {
            contactsTemp[index].role = value;
        } else if(key=='mobile') {
            contactsTemp[index].mobile = value;
        } else if(key=='landline') {
            contactsTemp[index].landline = value;
        } else if(key=='email') {
            contactsTemp[index].email = value;
        }

        this.setState({
            contacts: contactsTemp
        });
    }

    addMoreContact = () => {
        var contactsTemp = this.state.contacts;
        contactsTemp.push({
            type: 'Secondary Contact',
            fullname: '',
            role: '',
            mobile: '',
            landline: '',
            email: ''
        });
        contactsTemp.push({
            type: 'Secondary Contact',
            fullname: '',
            role: '',
            mobile: '',
            landline: '',
            email: ''
        });

        this.setState({
            contacts: contactsTemp
        });
    }

    saveDetails = () => {
        console.log('clicked');

        CorporateService.saveCorporateDetails(this.state.user_id, this.state.detailsCompany, this.state.detailsLandline, this.state.detailsAddress, this.state.detailsDiscountCode, this.state.detailsNoOfStaff, this.state.detailsRequirements, this.state.contacts, this.state.contactInfo)
        .then(response => {
            console.log({response});
            swal('Details Updated!', 'The company details have been updated', 'info');
        })
        .catch(error => {
            console.log({error});
        });
    }

    render() {

        if(this.state.allowed==false) {
            return (
                <NoPermission />
            );
        }
        
        return (
            <>
             <div className="row">
                <div className='col-12'>
                    <h3><AccountBoxIcon fontSize="large" /> Corporate Customer Details</h3>
                    <hr />
                </div>
            </div>
            <div className="row">
                <div className="col">
                    {(this.state.showloader == true) &&
                        <Loader className='loader-center'
                            type="Grid"
                            color="#00BFFF"
                            height={100}
                            width={100}
                        />
                    }
                </div>
            </div>
            {this.state.showloader==false &&    
            <div>           
            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col" style={{display: 'flex'}}>
                    <span style={{backgroundColor: '#ffe7ba', padding: '10px', fontWeight: 'bold', border: '1px solid grey', flexGrow: '1'}}>Corporate Details:</span>    
                </div>    
            </div>
            <div className="row">
                <div className="col">
                    <div className="form-group row">
                        <label for="detailsCompany" className="col-sm-3 col-form-label">Company Name:</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" id="detailsCompany" name="detailsCompany" value={this.state.detailsCompany} onChange={this.handleChange.bind(this)} placeholder="Company Name" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label for="detailsLandline" className="col-sm-3 col-form-label">Landline:</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" id="detailsLandline" name="detailsLandline" value={this.state.detailsLandline} onChange={this.handleChange.bind(this)} placeholder="Landline" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label for="detailsAddress" className="col-sm-3 col-form-label">Address:</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" id="detailsAddress" name="detailsAddress" value={this.state.detailsAddress} onChange={this.handleChange.bind(this)} placeholder="Address" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label for="detailsEmail" className="col-sm-3 col-form-label">Email:</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" id="detailsEmail" name="detailsEmail" value={this.state.detailsEmail} onChange={this.handleChange.bind(this)} placeholder="Email"  readOnly />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="form-group row">
                        <label for="detailsAccountCreationDate" className="col-sm-3 col-form-label">Account Creation Date:</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" id="detailsAccountCreationDate" name="detailsAccountCreationDate" value={this.state.detailsAccountCreationDate} onChange={this.handleChange.bind(this)} placeholder="Account Creation Date"  readOnly />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label for="detailsNoOfStaff" className="col-sm-3 col-form-label">No. of Staff</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" id="detailsNoOfStaff" name="detailsNoOfStaff" value={this.state.detailsNoOfStaff} onChange={this.handleChange.bind(this)} placeholder="No. of Staff" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label for="detailsDiscountCode" className="col-sm-3 col-form-label">Discount Coupon Code</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" id="detailsDiscountCode" name="detailsDiscountCode" value={this.state.detailsDiscountCode} onChange={this.handleChange.bind(this)} placeholder="Discount Coupon Code" readOnly />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label for="detailsTotalSalesAllTime" className="col-sm-3 col-form-label">Total Sales (all time)</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" id="detailsTotalSalesAllTime" name="detailsTotalSalesAllTime" value={this.state.detailsTotalSalesAllTime} onChange={this.handleChange.bind(this)} placeholder="Total Sales (all time)"  readOnly />
                        </div>
                    </div>
                </div>  
            </div>
            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col">
                    <label>Requirements / Important Info:</label>
                    <textarea className="form-controm" style={{width: '98%', height: '110px'}} name="detailsRequirements" value={this.state.detailsRequirements} onChange={this.handleChange.bind(this)} placeholder="Enter additional information or requirements"></textarea>
                </div>
            </div>
            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col" style={{display: 'flex'}}>
                    <span style={{backgroundColor: '#adffad', padding: '10px', fontWeight: 'bold', border: '1px solid grey', flexGrow: '1'}}>Corporate Contacts:</span>    
                </div>    
            </div>
            <div className="row" style={{marginBottom: '20px'}}>
                {this.state.contacts.map((contact, index) => (
                <div className="col-6" key={index}>
                    <div className="form-group row"><div className="col" style={{textDecoration: "underline"}}>{contact.type}:</div></div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Full Name:</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" value={contact.fullname} onChange={e => this.changeContact(index, 'name', e.target.value)} placeholder="Full Name:" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Role:</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" value={contact.role} onChange={e => this.changeContact(index, 'role', e.target.value)} placeholder="Role" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Mobile:</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" value={contact.mobile} onChange={e => this.changeContact(index, 'mobile', e.target.value)} placeholder="Mobile" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Landline:</label>
                        <div className="col-sm-9">
                        <input type="text" className="form-control" value={contact.landline} onChange={e => this.changeContact(index, 'landline', e.target.value)} placeholder="Landline" />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Email:</label>
                        <div className="col-sm-9">
                        <input type="email" className="form-control" value={contact.email} onChange={e => this.changeContact(index, 'email', e.target.value)} placeholder="Email" />
                        </div>
                    </div>
                </div> 
                ))}    
            </div>
            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col" style={{textAlign: 'right'}}>
                    <button className="btn btn-warning btn-sm" onClick={this.addMoreContact.bind(this)}>Add More Contacts</button>
                </div>
            </div>

            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col">
                    <label>Additional Info:</label>
                    <textarea className="form-controm" style={{width: '98%', height: '110px'}} name="contactInfo" value={this.state.contactInfo} onChange={this.handleChange.bind(this)} placeholder="Enter additional information or requirements"></textarea>
                </div>
            </div>

            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col" style={{display:'flex'}}>
                    <button className="btn btn-success btn-sm" style={{flexGrow: '1'}} onClick={this.saveDetails.bind(this)}>Save / Update Details</button>
                </div>
            </div>
            

            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col" style={{display: 'flex'}}>
                    <span style={{backgroundColor: 'rgb(254 210 210)', padding: '10px', fontWeight: 'bold', border: '1px solid grey', flexGrow: '1'}}>Orders & Booking Summary:</span>    
                </div>    
            </div>
            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col">
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Discount Coupon Code:</label>
                        <div className="col-sm-8">
                        <input type="text" className="form-control" value={this.state.detailsDiscountCode}  placeholder="Discount Coupon Code" readOnly />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Corporate Credit Balance:</label>
                        <div className="col-sm-8">
                        <input type="text" className="form-control" value={this.state.totalbalance} placeholder="Corporate Credit Balance" readOnly />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Last Order Date:</label>
                        <div className="col-sm-8">
                        <input type="text" className="form-control" value={this.state.lastorderdate} placeholder="Last Order Date" readOnly />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Order Details:</th>
                                <th>No. of Orders</th>
                                <th>Total Order Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">Past 30 days</th>
                                <td>{this.state.totalorders30days}</td>
                                <td>{this.state.total30days}</td>
                            </tr>
                            <tr>
                                <th scope="row">Past 12 months</th>
                                <td>{this.state.totalorders12months}</td>
                                <td>{this.state.total12months}</td>
                            </tr>   
                            <tr>
                                <th scope="row">All Time</th>
                                <td>{this.state.totalOrders}</td>
                                <td>{this.state.detailsTotalSalesAllTime}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <h5>Corporate Transaction & Credit History</h5>
                </div>
            </div>
            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col">
                    <table class="table" style={{textAlign: "center"}}>
                        <thead>
                            <tr>
                                <th>Order ID</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Order Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.history.length>0 && this.state.history.map((entry, index) => (
                            <tr key={index}>
                                <th scope="row">{entry.order_id}</th>
                                <td>{entry.amount}</td>
                                <td>{entry.status}</td>
                                <td>{entry.order_date}</td>
                            </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            </div>
            }
            </>
        );
    }
}